import Entity from './entity';
import TransferRegion from './transferRegion';
export default class TransferVehicle extends Entity<string> {

      imageUrl: string;
      name: string;
      description: string;
      passengerLimit: number;
      baggageLimit: number;
  
  
}
